import Box from '@mui/material/Box';
import type { ComponentType } from 'react';
import type { InsightsGridColumnSpan } from '../InsightsGrid/InsightsGrid';

const TILE_HEIGHT = 420;

type InsightsTileProps = {
  component: ComponentType;
  /** How many of the grid's 3 columns the tile occupies */
  columns?: InsightsGridColumnSpan;
  /** Lets the component render edge to edge (e.g. tabs spanning the tile's full width) */
  disablePadding?: boolean;
};

export const InsightsTile = ({ component: Component, columns = 1, disablePadding = false }: InsightsTileProps) => (
  <Box
    data-test="insights-tile"
    sx={{
      bgcolor: 'background.paper',
      border: theme => `1px solid ${theme.palette.background.grayLight}`,
      borderRadius: 1,
      gridColumn: { xs: '1 / -1', md: `span ${columns}` },
      height: TILE_HEIGHT,
      minWidth: 0,
      overflow: 'hidden',
      p: disablePadding ? 0 : 2.5,
    }}
  >
    <Component />
  </Box>
);
